import { render, staticRenderFns } from "./ModalVmodal.vue?vue&type=template&id=e80ddcbc&"
import script from "./ModalVmodal.vue?vue&type=script&lang=js&"
export * from "./ModalVmodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports